export default {"src":"/stays/_next/static/media/BookingCom.3c07d747.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};